import React from 'react';
import { useTranslation } from 'localization';

export interface MetricsBadgeAtomProps {
  subscriberCount?: number;
  importCount?: number;
  ratingAverage?: number;
  ratingCount?: number;
  compact?: boolean;
  className?: string;
}

const MetricsBadgeAtom: React.FC<MetricsBadgeAtomProps> = ({
  subscriberCount,
  importCount,
  ratingAverage,
  ratingCount,
  compact = false,
  className = '',
}) => {
  const { t } = useTranslation();

  // Coerce to number — API may return strings from COALESCE
  const rating = ratingAverage == null ? null : Number(ratingAverage);

  const hasMetrics =
    subscriberCount != null || importCount != null || rating != null;

  if (!hasMetrics) return null;

  const classes = [
    'marketplace-metrics-badge',
    compact ? 'marketplace-metrics-badge--compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {rating != null && rating > 0 && (
        <span className="marketplace-metrics-badge__item marketplace-metrics-badge__item--rating">
          <span className="marketplace-metrics-badge__star" aria-hidden="true">
            {'\u2605'}
          </span>
          <span className="marketplace-metrics-badge__value">
            {compact
              ? t('marketplace.metrics.ratingShort', {
                  rating: rating.toFixed(1),
                })
              : (() => {
                  const ratingSuffix = ratingCount == null ? '' : ` (${t('marketplace.ratings.ratingCount', { count: ratingCount })})`;
                  return `${rating.toFixed(1)}${ratingSuffix}`;
                })()}
          </span>
        </span>
      )}
      {subscriberCount != null && (
        <span className="marketplace-metrics-badge__item marketplace-metrics-badge__item--subscribers">
          <span className="marketplace-metrics-badge__value">
            {compact
              ? t('marketplace.metrics.subscribers', { count: subscriberCount })
              : t('marketplace.common.subscriberCount', {
                  count: subscriberCount,
                })}
          </span>
        </span>
      )}
      {importCount != null && importCount > 0 && (
        <span className="marketplace-metrics-badge__item marketplace-metrics-badge__item--imports">
          <span className="marketplace-metrics-badge__value">
            {compact
              ? t('marketplace.metrics.imports', { count: importCount })
              : t('marketplace.common.importCount', { count: importCount })}
          </span>
        </span>
      )}
    </div>
  );
};

export default MetricsBadgeAtom;
